import { supabase } from "@/lib/supabase/supabaseClient";
import { GetSurveysByProjectIdProps } from ".";

export const getSurveysByProjectId = async ({
  projectId,
  archived = false,
  sortByCreatedAtAscending = false,
}: GetSurveysByProjectIdProps) => {
  return await supabase
    .from("survey")
    .select(
      `
        *,
        author:user!author_id(*),
        crm(*),
        crm_config(*),
        project(*)
    `
    )
    .eq("project_id", projectId)
    .eq("archived", archived)
    .order("created_at", { ascending: sortByCreatedAtAscending })
    .throwOnError()
    .then((res) => res.data);
};
